<button class="btn btn-light btn-sm" title="Search AppMapPaths" (click)="openSearch()">
    <i id="button_Search"></i>
</button>
<ng-template #appMapSearchTemplate>
    <div class="modal-header pt-2 pb-2 headerBackground">
       
       <h6 class="modal-title pull-left ">AppMap Search</h6>
       <button type="button " class="btn-close pull-right" aria-label="Close"
           (click)="modalRef.hide();">
           
       </button>
    </div>
  
    <div class="modal-body"> 
              
      <div class="row">
        <div class="col-md-12">
            <form>
              <div class="input-group mb-3">
                  <input #autocompleteInput 
                  class='form-control'
                  [value]="searchedTerm" 
                  type="text"
                  [placeholder]="placeholder" 
                  aria-label="Number"  
                  [formControl]="searchControl" />
                  <!--<span class="input-group-btn">-->
                    <button class="btn btn-sm btn-outline-secondary" (click)="processSearchAction('')">
                      <i id="button_Search"></i>
                    </button>
                  <!--</span>-->
                
               </div>
              </form>
            </div>
            <div class="col-md-12 mt-2">
              <table  class="table  table-sm" *ngIf="isSearchProceed">
                <thead class="dragula-thead">
                    <th>
                       Results
                    </th>
                </thead>
                <tbody id="appMapSearchResult" *ngIf="(appMapSearchList.length >0)">
                 
                    <tr id="ai">
                        <td></td>
                    </tr>
                    <tr  *ngFor="let searchOptions of appMapSearchList">
                        <td>
                          <ng-container *ngFor="let sop of searchOptions"> 
                            <ng-container  *ngIf="(sop.ID != null)" >
                              <!--<FUTURE-ENABLE>: Hyperlink will be back once process definition will be finalized-->
                              <!--<a (click)="loadPathLocation(sop);modalRef.hide();">{{sop.displayName}}</a>-->
                              {{sop.displayName}}
                            </ng-container>
                            <ng-container  *ngIf="(sop.ID == null)" >
                              {{sop.displayName}}
                            </ng-container>
                          </ng-container>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="(appMapSearchList.length == 0)">
                  <tr id="ai">
                    <td>Results are not found</td>
                </tr>
                  
                </tbody>
            </table>
          
            
        </div> 
    </div>
    </div>
    <div class="modal-footer ">
      <button class="btn btn-secondary btn-sm"
      (click)="modalRef.hide();isSearchProceed=false;">Close</button>
    </div>
</ng-template>
